import { IconBase, IconBaseProps } from 'react-icons';

export function LinkIcon(props: IconBaseProps) {
    return (
        <IconBase id="link-icon" data-testid="LinkIcon" {...props} viewBox="0 0 15 14">
            <path
                d="M7.42 1.42a4 4 0 1 1 5.66 5.66l-.93.9a.75.75 0 0 1-1.04-1.07l.91-.9a2.5 2.5 0 0 0-3.54-3.53l-.9.91a.75.75 0 0 1-1.07-1.04l.91-.93ZM10.3 4.2c.3.3.3.77 0 1.06L5.76 9.8A.75.75 0 0 1 4.7 8.74L9.24 4.2c.3-.3.77-.3 1.06 0ZM3.9 6.03c.3.3.3.77 0 1.06l-.93.9a2.5 2.5 0 1 0 3.53 3.54l.01-.01.92-.92a.75.75 0 0 1 1.06 1.06l-.91.91a4 4 0 1 1-5.65-5.66l.92-.9a.75.75 0 0 1 1.06.02Z"
                fill="currentColor"
            />
        </IconBase>
    );
}
